import type { ErrorDetails } from '@questaurant/lib-shared';

/**
 * The client-side view of the canonical error envelope (00 §7.1). Every failure
 * the HTTP client surfaces — transport, timeout, or a real API error — arrives
 * as one of these, so callers never branch on `fetch` internals.
 */
export class ApiClientError extends Error {
  readonly code: string;
  readonly status: number;
  readonly details?: ErrorDetails;
  readonly requestId?: string;

  constructor(init: {
    code: string;
    message: string;
    status: number;
    details?: ErrorDetails;
    requestId?: string;
  }) {
    super(init.message);
    this.name = 'ApiClientError';
    this.code = init.code;
    this.status = init.status;
    this.details = init.details;
    this.requestId = init.requestId;
  }
}

/** True when a retry could plausibly succeed (network blip or 5xx). */
export function isRetryable(error: unknown): boolean {
  return (
    error instanceof ApiClientError &&
    (error.status >= 500 || error.status === 0)
  );
}
